// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  margin: -1rem -1rem 1rem -1rem;
  padding: 2rem 1rem 0 1rem;
}`, "",{"version":3,"sources":["webpack://./libs/msslib/src/lib/components/formly/wrappers/header/header-wrapper.component.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;EACA,yBAAA;AACF","sourcesContent":[".header {\n  margin: -1rem -1rem 1rem -1rem;\n  padding: 2rem 1rem 0 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
